
// Supp application fields (#721 spec §6.3). Shown when a Supp application is
// involved; the confirmed premium only when switching supplements.
export default {
    props: {
        rec: { type: Object, required: true },
        underwriting: { type: String, default: 'yes' },
        showPremium: { type: Boolean, default: false },
    },
    data () {
        return {
            options: [
                { value: 'yes', text: 'Yes, medical underwriting' },
                { value: 'no', text: 'No (guaranteed issue, birthday rule or carrier switch program)' },
            ],
        }
    },
}
